import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    poserlist: [],
    updatePosterDialog: false,
    totalCount: 0
  },
  getters: {},
  mutations: {
    setposerlist(state, payload) {
      state.poserlist = payload.list;
      state.totalCount = payload.totalCount;
    },
    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    }
  },
  actions: {
    createCom(context, data) {
      return api.createCom(data);
    },
    list({ commit }, data) {
      api.getList(data).then(({ data }) => {
        commit('setposerlist', data);
      });
    },
    remove(context, data) {
      return api.removeList(data);
    }
  }
};

appStore.registerModule('community', store);
